module.exports = __webpack_public_path__ + "static/media/lista-korisnika.531face5.svg";